<template>
    <nav>
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType" 
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <DashboardHeader />
      <v-row>
        <v-col
          cols="11"
          class="mx-auto"
        >
          <p 
            :class="mobile() ? 'text-h5 font-weight-bold ml-16 mr-16' : 'text-h5 font-weight-bold'"
            :align="mobile() ? 'center' : 'left'"
          >
            {{ $t('eventsTitle') }}
          </p>
          <p class="text-body-1 greytext--text d-none d-sm-block">
            {{ $t('eventsText') }}
          </p>
        </v-col>
      </v-row>
      <v-row
        v-if="(!events || events.length == 0) && eventsInfo.currentPage == 1 && !loadingData"
        align="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="4"
          offset-sm="2"
          offset-md="3"
          offset-lg="4"
          align="center"
        >
          <EmptyPage
            :page-title="$t('emptyeventsPageTitle')"
            :page-text="$t('emptyeventsPageText')"
            page-image="image1"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="events.length > 0 && !loadingData"
        align="center"
        class="mx-auto"
      >
        <v-col
          cols="11"
          class="mx-auto px-0"
        >
          <v-card
            v-for="(event) in events"
            :key="event.id"
            :ripple="false"
            data-testid="target-group-card"
            rounded="xxl"
            class="my-2 solo"
          >
            <v-hover v-if="mobile()">
              <v-row
                v-if="mobile()"
                slot-scope="{ hover }"
                no-gutters
                :class="`py-3 elevation-${hover? 8 : 2 }`"
              >
                <v-col
                  cols="11"
                  align-self="center"
                  class="px-6"
                >
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ event.attributes.title }}
                  </v-card-text>
                </v-col>
           
              </v-row>
            </v-hover>
            <v-hover v-if="!mobile()">
              <v-row
                v-if="!mobile()"
                slot-scope="{ hover }"
                no-gutters
                :class="`py-3 elevation-${hover? 8 : 2 }`"
              > 
                <v-col
                  cols="12"
                  md="3"
                  class="px-6"
                >
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('title') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    {{ event.attributes.title }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="3"
                  class="px-6"
                >
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('labelEventDate') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    {{ format_date(event.attributes.event_at) }}
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="px-6"
                >
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('linkOrAddress') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    
                    <a :href="event.attributes.event_type == 'digital' ? event.attributes.information.url : event.attributes.information.googleMapsLink" target="_blank">
                      {{ event.attributes.event_type == 'digital' ? event.attributes.information.url : event.attributes.information.address }}
                    </a>
                  </div>
                </v-col>

              
              </v-row>
            </v-hover>
          </v-card>
        </v-col>
      </v-row>
      <Pagination
        v-if="events.length > 0"
        v-model="pageNumber"
        class="mb-16"
        circle
        :data-length="eventsInfo.total"
        :page-number="eventsInfo.currentPage"
        total-visible="5"
        :size="size"
        @input="handlePageChange"
        :key="paginationKey"
      />
   
    </nav>
  </template>    
  <script>
  import moment from 'moment'
  import i18n from '../../plugins/i18n'
  import Pagination from '../../components/Pagination'
  import EmptyPage from '../../components/EmptyPage'
  import { getEvents } from '../../api/eventApi'
  import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
  import AlertMessages  from '../../components/AlertMessages'
  import DashboardHeader from '../../components/DashboardHeader'
  
  export default {
      components: { 
          EmptyPage,
          Pagination,
          AlertMessages,
          DashboardHeader
      },
      mixins: [repeatedMethodsMixin],
      data(){
          return{
              events: [],
              link: {title: i18n.t('createEventTitle'), route: '/target-groups/create'},
              alertType: '',
              alertMsg: '',
              alertValue:false,
              eventsInfo: {
                currentPage: 1,
                total: 1,
              },
              spaceId: window.$cookies.get('space_id'),
              pageNumber: 1,
              size: 15,
              loadingData: false,
              confirmationDialogTitle: '',
              confirmationDialogText: '',
              confirmationDialogCancelBtn: '',
              confirmationDialogSubmitBtn: '',
              dialogVisible: false,
              selectedTargetIdForDeletion: '',
              paginationKey: ''
          }
      },
      computed: {
          filteredItems(){
               return this.events.filter((item) =>{
                  if(!this.searchTerm) return this.events
                  return item.name.toLowerCase().match(this.searchTerm.toLowerCase())
              })
          },
          paginatedData() {
              const start = this.pageNumber * this.size - this.size,
              end = start + this.size
              return this.filteredItems.slice(start, end)
          },
          productPlan() {
              return this.$store.state.productPlan;
          },
      },
      async created(){
          this.loadingData = true
          await this.fetchEvents()
          this.loadingData = false
      },
      methods: {
          handlePageChange(value){
              this.eventsInfo.currentPage = value
              this.pageNumber = value
              this.fetchEvents()
          },
          format_date(value){
            if (value) {
              return moment(String(value)).format('DD MMM YYYY, HH:mm')
            }
        },
          async fetchEvents(){
              try {
                  const response = await getEvents(this.spaceId, this.pageNumber, this.size)
                  if(response.status){
                      if(response.status == 200) {
                          this.events = response.data.data
                          if(this.events.length == 0 && response.data.meta.page.total > 0){
                              this.pageNumber = 1
                              await this.fetchEvents()
                          }else {
                            this.eventsInfo = response.data.meta.page
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                          }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
              }
          }
      },
  }
  </script>
  